import { Flex, Spin, Typography } from 'antd';

interface LoadingScreenProps {
  label?: string;
  compact?: boolean;
}

export const LoadingScreen = ({
  label = 'در حال بارگذاری اطلاعات…',
  compact = false,
}: LoadingScreenProps): React.ReactElement => (
  <Flex
    vertical
    align="center"
    justify="center"
    gap={16}
    className={compact ? 'loading-screen loading-screen--compact' : 'loading-screen'}
  >
    <Spin size="large" />
    <Typography.Text type="secondary">{label}</Typography.Text>
  </Flex>
);
